// Sidebar Routers
export const employeeMenus = {
    "lang.general": [
        { action: "space_dashboard", title: "lang.dashboard", active: false, path: "/dashboard", name: "dashboard", exact: true },
        { action: "contacts", title: "lang.customers", path: "/customers", name: "customers", exact: true, module: "companies" },
        {
            action: "local_fire_department",
            title: "lang.heat_treat",
            active: false,
            name: "heat_treat",
            items: [
                {
                    action: "inventory",
                    title: "lang.receiving",
                    path: "/receiving",
                    name: "receiving",
                    exact: true,
                    icon_class: "material-icons-outlined",
                    module: "receiving",
                    permission: "receiving.read",
                },
                {
                    action: "schedule",
                    title: "lang.batch_line",
                    exact: true,
                    menu: "batchMenu",
                    path: "/batch_line",
                    module: "scheduling",
                    permission: "scheduling.read",
                },
                {
                    action: "schedule",
                    title: "lang.continuous",
                    exact: true,
                    menu: "continuousMenu",
                    path: "/continuous",
                    module: "scheduling",
                    permission: "scheduling.read",
                },
                {
                    action: "biotech",
                    title: "lang.qc_inspection",
                    path: "/quality_control",
                    name: "quality_control",
                    exact: true,
                    module: "qc_inspection",
                    permission: "qc_inspection.read",
                },
                {
                    action: "unarchive",
                    title: "lang.repack",
                    path: "/repack",
                    name: "repack",
                    exact: true,
                    icon_class: "material-icons-outlined",
                    module: "repack",
                    permission: "repack.read",
                },
                {
                    action: "local_shipping",
                    title: "lang.packing_lists",
                    path: "/packing_lists",
                    name: "packing_lists",
                    exact: true,
                    icon_class: "material-icons-outlined",
                    module: "packing_lists",
                    permission: "packing_lists.read",
                },
                {
                    action: "attach_money",
                    title: "lang.invoices",
                    path: "/invoices",
                    name: "invoices",
                    exact: true,
                    icon_class: "material-icons-outlined",
                    module: "invoices",
                    permission: "invoices.read",
                },
                {
                    action: "report",
                    title: "lang.nonconformance",
                    path: "/nonconformance",
                    name: "nonconformance",
                    exact: true,
                    icon_class: "material-icons-outlined",
                    module: "nonconformance",
                    permission: "nonconformance.read",
                },
                // {
                //     action: "sell",
                //     title: "lang.nonconformance_hold_tags",
                //     path: "/nonconformance_hold_tags",
                //     name: "nonconformance_hold_tags",
                //     exact: true,
                //     icon_class: "material-icons-outlined",
                //     module: "nonconformance_hold_tags",
                //     permission: "nonconformance_hold_tags.read",
                // },
                { action: "settings", title: "lang.parts", path: "/parts", name: "parts", exact: true, module: "parts", permission: "parts.read" },
            ],
        },
        {
            action: "shopping_cart",
            title: "lang.sales",
            name: "sales",
            active: false,
            exact: false,
            path: "sales",
            items: [
                {
                    action: "inventory",
                    icon_class: "material-icons-outlined",
                    title: "lang.requests_for_estimates",
                    path: "/sales/quote_requests",
                    name: "quote_requests",
                    exact: true,
                    module: "quote_requests",
                    permission: "quote_requests.read",
                },
                {
                    action: "difference",
                    icon_class: "material-icons-outlined",
                    title: "lang.fe_menu_quotes",
                    path: "/sales/quotes",
                    name: "quotes",
                    exact: true,
                    module: "quotes",
                    permission: "quotes.read",
                },
                {
                    action: "add_shopping_cart",
                    icon_class: "material-icons-outlined",
                    title: "lang.fe_menu_orders",
                    path: "/sales/orders",
                    name: "orders",
                    exact: true,
                    module: "orders",
                    permission: "orders.read",
                },
                {
                    action: "attach_money",
                    icon_class: "material-icons-outlined",
                    title: "lang.fe_menu_invoices",
                    path: "/sales/fe_invoices",
                    name: "fe_invoices",
                    exact: true,
                    module: "fe_invoices",
                    permission: "fe_invoices.read",
                },
                {
                    action: "handyman",
                    icon_class: "material-icons-outlined",
                    title: "lang.projects",
                    path: "/sales/projects",
                    name: "projects",
                    exact: true,
                    module: "projects",
                    permission: "projects.read",
                },
                {
                    action: "settings",
                    title: "lang.fe_menu_parts",
                    path: "/inventory/fe_parts",
                    name: "fe_parts",
                    exact: true,
                    module: "fe_parts",
                    permission: "fe_parts.read",
                },
                {
                    action: "receipt",
                    icon_class: "material-icons-outlined",
                    title: "lang.fe_menu_invoice_payments",
                    path: "/sales/payments",
                    name: "payments",
                    exact: true,
                    module: "payments",
                    permission: "invoices.read",
                },
            ],
        },
        {
            action: "shopping_bag",
            title: "lang.purchasing",
            name: "purchasing",
            active: false,
            exact: false,
            path: "purchasing",
            items: [
                {
                    action: "inventory",
                    icon_class: "material-icons-outlined",
                    title: "lang.fe_menu_rfq",
                    path: "/purchasing/rfqs",
                    name: "rfqs",
                    exact: true,
                    module: "rfqs",
                    permission: "rfqs.read",
                },
                {
                    action: "request_quote",
                    icon_class: "material-icons-outlined",
                    title: "lang.fe_menu_po",
                    path: "/purchasing/purchase_orders",
                    name: "purchase_orders",
                    exact: true,
                    module: "purchase_orders",
                    permission: "purchase_orders.read",
                },
                {
                    action: "receipt_long",
                    icon_class: "material-icons-outlined",
                    title: "lang.fe_menu_inventory_receipts",
                    path: "/purchasing/inventory_receipts",
                    name: "inventory_receipts",
                    exact: true,
                    module: "inventory_receipts",
                    permission: "inventory_receipts.read",
                },
                {
                    action: "description",
                    icon_class: "material-icons-outlined",
                    title: "lang.fe_menu_bills",
                    path: "/purchasing/bills",
                    name: "bills",
                    exact: true,
                    module: "bills",
                    permission: "bills.read",
                },
                {
                    action: "payments",
                    icon_class: "material-icons-outlined",
                    title: "lang.fe_menu_bill_payments",
                    path: "/purchasing/payments",
                    name: "payments",
                    exact: true,
                    module: "payments",
                    permission: "bills.read",
                },
            ],
        },

        { action: "people", title: "lang.people", path: "/people", name: "people", exact: true, module: "people", permission: "people.read" },
    ],
};

export const customerMenus = {
    "lang.general": [
        {
            action: "space_dashboard",
            title: "lang.dashboard",
            active: false,
            path: "/home",
            name: "dashboard",
            exact: true,
            module: "dashboard",
            permission: "dashboard.read",
        },
        {
            action: "inventory",
            icon_class: "material-icons-outlined",
            title: "lang.requests_for_estimates",
            path: "/sales/quote_requests",
            name: "quote_requests",
            exact: true,
            module: "quote_requests",
            permission: "quote_requests.read",
        },
        {
            action: "difference",
            icon_class: "material-icons-outlined",
            title: "lang.fe_menu_quotes",
            path: "/sales/quotes",
            name: "quotes",
            exact: true,
            module: "quotes",
            permission: "quotes.read",
        },
        {
            action: "add_shopping_cart",
            icon_class: "material-icons-outlined",
            title: "lang.fe_menu_orders",
            path: "/sales/orders",
            name: "orders",
            exact: true,
            module: "orders",
            permission: "orders.read",
        },
        {
            action: "attach_money",
            icon_class: "material-icons-outlined",
            title: "lang.fe_menu_invoices",
            path: "/sales/fe_invoices",
            name: "fe_invoices",
            exact: true,
            module: "fe_invoices",
            permission: "fe_invoices.read",
        },
        {
            action: "handyman",
            icon_class: "material-icons-outlined",
            title: "lang.projects",
            path: "/sales/projects",
            name: "projects",
            exact: true,
            module: "projects",
            permission: "projects.read",
        },
        // {
        //     action: "inventory",
        //     title: "lang.receiving",
        //     path: "/receiving",
        //     name: "receiving",
        //     exact: true,
        //     icon_class: "material-icons-outlined",
        //     module: "receiving",
        //     permission: "receiving.read",
        // },
        // { action: "schedule", title: "lang.batches", exact: true, module: "batch", path: "/batch", name: "batch", permission: "batch.read" },
        // {
        //     action: "local_shipping",
        //     title: "lang.packing_lists",
        //     path: "/packing_lists",
        //     name: "packing_lists",
        //     exact: true,
        //     icon_class: "material-icons-outlined",
        //     module: "packing_lists",
        //     permission: "packing_lists.read",
        // },
        // {
        //     action: "attach_money",
        //     title: "lang.invoices",
        //     path: "/invoices",
        //     name: "invoices",
        //     exact: true,
        //     icon_class: "material-icons-outlined",
        //     module: "invoices",
        //     permission: "invoices.read",
        // },
    ],
};

export const vendorMenus = {
    "lang.general": [
        { action: "space_dashboard", title: "lang.dashboard", active: false, path: "/dashboard", name: "dashboard", exact: true },
        {
            action: "inventory",
            icon_class: "material-icons-outlined",
            title: "lang.fe_menu_rfq",
            path: "/purchasing/rfqs",
            name: "rfqs",
            exact: true,
            permission: "rfqs.read",
            module: "rfqs",
        },
        {
            action: "request_quote",
            icon_class: "material-icons-outlined",
            title: "lang.fe_menu_po",
            path: "/purchasing/purchase_orders",
            name: "purchase_orders",
            exact: true,
            permission: "purchase_orders.read",
            module: "purchase_orders",
        },
        {
            action: "receipt_long",
            icon_class: "material-icons-outlined",
            title: "lang.fe_menu_inventory_receipts",
            path: "/purchasing/inventory_receipts",
            name: "inventory_receipts",
            exact: true,
            permission: "inventory_receipts.read",
            module: "inventory_receipts",
        },
        {
            action: "description",
            icon_class: "material-icons-outlined",
            title: "lang.fe_menu_bills",
            path: "/purchasing/bills",
            name: "bills",
            exact: true,
            permission: "bills.read",
            module: "bills",
        },
        {
            action: "payments",
            icon_class: "material-icons-outlined",
            title: "lang.fe_menu_bill_payments",
            path: "/purchasing/payments",
            name: "payments",
            exact: true,
            permission: "bills.read",
            module: "bills",
        },

        // { action: 'schedule', title: 'lang.batch_line', path: '/batch_line', name: 'batch_line', exact: true },
        //{ action: "people", title: "lang.people", path: "/people", name: "people", exact: true, module: "people", permission: "people.read" },
    ],
};

export const continuousMenus = {
    sub_menu: [
        {
            action: "view_agenda",
            title: "lang.scheduler",
            active: false,
            path: "/continuous/schedule",
            name: "continuous_schedule",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "continuous",
        },
        {
            action: "unarchive",
            title: "lang.setting",
            path: "/continuous/setting",
            name: "continuous_setting",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "continuous",
        },
        { action: "restore", title: "lang.production", path: "/continuous/production", name: "continuous_production", exact: true, menu_title: "continuous" },
    ],
};
export const batchMenus = {
    sub_menu: [
        {
            action: "view_agenda",
            title: "lang.scheduler",
            active: false,
            path: "/batch_line/schedule",
            name: "batch_line",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
        },
        {
            action: "unarchive",
            title: "lang.setting",
            active: false,
            path: "/batch_line/setting",
            name: "batch_line_setting",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
        },
        {
            action: "restore",
            title: "lang.production",
            active: false,
            path: "/batch_line/production",
            name: "batch_line_production",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
            divider: true,
        },
        {
            action: "recycling",
            title: "lang.scrap_authorization",
            active: false,
            path: "/scrap_authorizations",
            name: "scrap_authorizations",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
        },
        {
            action: "article",
            title: "lang.honing_process_checklist",
            active: false,
            path: "/batch_line/logs/form/honing_process_check_sheet",
            name: "logs_form",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
        },
        {
            action: "article",
            title: "lang.hourly_operation_log",
            active: false,
            path: "/batch_line/logs/form/hourly_operation_log",
            name: "logs_form_hourly_operation_log",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
        },
        {
            action: "article",
            title: "lang.furnace_checklist",
            active: false,
            path: "/batch_line/logs/form/furnace_check_sheet",
            name: "log_form_furnace_checklist",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
        },
        {
            action: "article",
            title: "lang.paint_process_checklist",
            active: false,
            path: "/batch_line/logs/form/paint_process_check_sheet",
            name: "logs_form_paint_process_check_sheet",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
        },
        {
            action: "article",
            title: "lang.tempering_furnace_check_sheet",
            active: false,
            path: "/batch_line/logs/form/tempering_furnace_check_sheet",
            name: "logs_form_tempering_furnace_check_sheet",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
        },
        {
            action: "article",
            title: "lang.vacuum_washer_check_list",
            active: false,
            path: "/batch_line/logs/form/vacuum_washer_check_list",
            name: "logs_form_vacuum_washer_check_list",
            exact: true,
            icon_class: "material-icons-outlined",
            menu_title: "batch_line",
        },
    ],
};

export const menu = {};
